// extracted by mini-css-extract-plugin
export default {"cta":"KI-z","disabled":"LI-z"};